import { inject } from 'aurelia-framework';
import { Api } from './services/api';
import { Request, DataService, AuthStatus, CookieDomain } from './services/data-service';
import { Router } from 'aurelia-router';

const AppEnviroment = { "Production":"production", "Dev":"dev" };
let   app_env		= AppEnviroment.Production;
const app_redirect 	= (app_env === AppEnviroment.Dev) ? "http://localhost:8082" : "https://app.samantia.com";


const Subscriptions = {
	"Trial": {
		type:"Trial", code:"TRIAL0625",
		billing_period:"Annual", ammount:0,
		cases:1, storage:50, trainings:2, predictions:5000
	},
}


@inject(Api, DataService, Router)
export class Signup {

	/** Component methods **/
	constructor(api, ds, router){
		this.api 		= api;
		this.ds			= ds;
		this.router		= router;
		this.formData 	= { username:"", email: "", password:""};
	}


	/* MARK: Remote API Calls
	   ============================================
	*/

		
	postSubscription(subs, uid){
		let authRequest 	= new Request("/api/v2/subscriptions/", "POST");

		let subscription	= { type:subs.type, billing_period:subs.billing_period, code:subs.code}
		let body 			= { subscription:subscription, uid:uid };
		authRequest.body	= JSON.stringify(body);
		//console.log("body => ", body);
		return this.api.post(authRequest);
	}

	handlePostSubscription(response){
		console.log("subs res => ", response);
	}

	/** Custom methods **/
	signup(data){
		let req = new Request("/api/v2/users/", "POST");
		req.body = JSON.stringify(data);
		this.api.post(req).then(response => {
			// 200 sucess
			console.log("response => ", response);
			if (response.status === 200){
				// login user
				// Add Trial subscription
				// Then Reload 
				//this.login(data);
				return this.postSubscription(Subscriptions.Trial, response.data._id)
			}
			
		})
		.then(res_subs => {
			// Login user
			let status = res_subs.status
			if(status === 200){ this.login(data); }
			//this.login(data);
		})
		.catch( (err) => { console.log("err: ", err);});
	}


	// Auto login
	login(data){
		// Create Request
		let request = new Request("/api/v2/sessions/", "POST");
		request.body = JSON.stringify(data);
		this.api.post(request).then(response => {

			if(response.status === 201){
				// Update variables
				this.auth_token = response.authToken;
				this.response = response;
				// Store cookie with authToken
				// let cookie = response.data.uid + "=" + response.data.authToken + ";domain=localhost;SameSite=None;Secure";

				
				//let cookie = "S6session" + "=" + response.data.authToken + ";domain=localhost;path=/;SameSite=None;Secure";
				//let cookie = "S6session" + "=" + response.data.authToken + ";domain=samantia.com;path=/;SameSite=None;Secure";

				let cookie = "S6session" + "=" + response.data.authToken + CookieDomain;
				
				document.cookie = cookie;
				// Aunthenticate user
				this.ds.auth_status = AuthStatus.Ok;
				this.authToken = response.data.authToken;
				this.ds.user = response.data;

				// => this.router.navigateToRoute('user-detail', {id:response.data.uid} );
				window.location.href = "https://app.samantia.com";
			}
		});
	}
	
}
